


























import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { ReceptionComment } from "../../../../domain/workflow/reception";
import { ModelEditableMixin } from "../../../system/mixins";

@Component
export default class ReceptionDetailCommentEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: ReceptionComment) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ReceptionComment) => T, defaultValue: T) => T;

  @Prop()
  isEditable: boolean;

  @Prop()
  comments: ReceptionComment[];

  @Prop()
  label: string;

  @Prop({ default: false })
  isCommentConflicted: boolean;

  @Prop()
  showCommentDialog: (source: string, title: string, write: (text: string) => void) => Promise<void>;

  @Prop()
  detailId: number;

  @Prop()
  commentType: string;

  @Emit()
  conflictResolved(confirmedComment: ReceptionComment): void {}

  data(): any {
    return {
      isConflictResolved: false,
    };
  }
  isConflictResolved: boolean;

  get content(): string {
    return this.readPropertyOrDefault(s => s.content, "");
  }

  set content(value: string) {
    this.writePropertyWhenValid(s => s.content = value);
  }

  get updateDateTime(): Date {
    return this.readPropertyOrDefault(s => s.updateDateTime, null);
  }

  get isConflicted(): boolean {
    return this.isCommentConflicted && !this.isConflictResolved;
  }

  get conflictedMessage(): string {
    return this.isConflicted
      ? "最新と異なります。"
      : "";
  }

  get noticeIndicationBackgroundColor(): string {
    return this.$configuration.style.noticeIndication.backgroundColor;
  }

  get indicationStyle(): any {
    return {
      backgroundColor: this.isConflicted ? this.noticeIndicationBackgroundColor : null,
    };
  }

  showCommentDialogIntoComment(): void {
    const textarea = this.$refs.comment;
    if (!(textarea instanceof HTMLTextAreaElement)) {
      return;
    }
    this.showCommentDialog(textarea.value, this.label, text => this.content = text);
  }

  async showCommentConflictDialog(): Promise<void> {
    if (!this.isConflicted) { return; }
    const latestComment = await this.getCommentByDetailIdAndCommentType(this.detailId, this.commentType);
    if (!latestComment || latestComment.updateDateTime < this.updateDateTime) { return; }

    const editedComment = await this.$commonDialogs.workflow.conflictCommentComparer.show(this.label + "編集", this.label, this.content, latestComment, true);
    if (editedComment !== undefined) {
      this.content = editedComment;
      this.isConflictResolved = true;
      this.conflictResolved(latestComment);
    }
  }

  async getCommentByDetailIdAndCommentType(detailId: number, type: string): Promise<ReceptionComment> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.getCommentByDetailIdAndCommentType(detailId, type);
      return result;
    } catch (e) {
      this.$error("最新コメント取得失敗", "最新のコメント取得に失敗しました。", e);
    }
  }

  contextmenu(e: PointerEvent) {
    this.$showTextInputContextMenu(e);
  }

  @Watch("isCommentConflicted")
  onIsCommentConflictedChanged(newValue: boolean): void {
    if (newValue) {
      this.isConflictResolved = false;
    }
  }
}
